import React from "react"
import { Link } from "react-router"

import { Link as MuiLink } from "@mui/material"

interface AdminEntityLinkProps {
  label: string
  to?: string
}

export const AdminEntityLink: React.FC<AdminEntityLinkProps> = ({
  label,
  to,
}) => {
  if (!to) {
    return label
  }

  return (
    <MuiLink component={Link} to={to}>
      {label}
    </MuiLink>
  )
}
